const getErrorMessage = error => {
  if (!error) return undefined

  if (typeof error.message === 'string') {
    return error.message
  }

  if (Array.isArray(error)) {
    return error.map(getErrorMessage).find(Boolean)
  }

  if (typeof error === 'object') {
    return Object.values(error)
      .map(getErrorMessage)
      .find(Boolean)
  }

  return undefined
}

export const getFirstErrorMessage = formErrors =>
  Object.values(formErrors || {})
    .map(getErrorMessage)
    .find(Boolean)
